import React, {useEffect, useState} from 'react';

import {one, two, four, eight, sixteen, thirtytwo, sixtyfour} from './../service/rights'
import RegionAuto from './../components/RegionAuto';

const rightList = [
  {id: 1, label: 'View users (1)', width: 60.48},
  {id: 2, label: 'Add and Edit users (2)', width: 94.85}, 
  {id: 4, label: 'View payments (4)', width: 94.39}, 
  {id: 8, label: 'Add payments (8)', width: 94.39},
  {id: 16, label: 'Delete payments (16)', width: 94.39},
  {id: 32, label: 'Add currencies rates (32)', width: 97.9}, 
  {id: 64, label: 'View operators (64)', width: 60.48},
  {id: 128, label: 'Administrator (all rights are included) (128)', width: 126.75}
] 


const Modal = ({regionL, regions, curUserName, domain, fetchList}) => {
  const [modal, setModal] = useState(false);
  const setStatus = () => {
      setModal(!modal);
      document.body.style.overflow = !modal ? "hidden" : "auto";
  }
    // const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [regionId, setRegionId] = useState('');
    const [region, setRegion] = useState(regionL);
    const [phone, setPhone] = useState('');
    const nameChange = (event) => {
        setName(event.target.value)
    };
    const emailChange = (event) => {
        setEmail(event.target.value);
    }
    const phonesChange = (event) => {
        setPhone(event.target.value);
    }

    const [rightsLevel, setRightsLevel] = useState(0);
    const [rightLvl, setRightsLvl] = useState(null);
    const listChange = (checked, index, lvl) => {
      let updated = [...rightLvl];
      if (index === 7 && checked) {
        updated = rightList.map(obj => ({lvl: obj.id, access: checked}))
      }else{
        updated[index] = {lvl: lvl, access: checked}
        if (!checked) updated[7].access = false;
      }
      setRightsLvl(updated)
    }

    const rightChoose = () => {
      return <table>
        <tr> 
          {rightList.map(right => 
            <th className='rights-in' style={{width: right.width, padding: '5px'}} key={right.id}>
              {right.label}
            </th>
          )} 
        </tr>
        <tr> 
          {rightList.map((right, index) => {
            const check = rightLvl ? rightLvl[index].access : false;
            return (
              <th className='rights-in' width={right.width} key={right.id}>
                <input type="checkbox" checked={check} onChange={(e) => {listChange(e.target.checked, index, right.id)}}/> 
              </th>)
          })} 
        </tr>
      </table>
    }
    
    function removeSpaces(str) {
        return str.replace(/\s+/g, '');
    }   

    const fetchOperator = async() => {
      try{
        const responce = await fetch(`https://${domain}/api/operator/profile/${removeSpaces(curUserName)}`);
        if(!responce.ok) throw new Error();
        const data = await responce.json();
        setName(data?.name || '');
        setEmail(data?.email || '');
        setRegion(data?.region || '');
        setRegionId(data?.region_id || 0);
        // setPassword(data.password || '');
        setPhone(data?.phone || '');
        setRightsLevel(data?.rights || 0);
      }catch(e){console.error(e)}
    } 

    const fetchChanges = async () => {
      const requestBody = {
        login: curUserName,
        // password: password,
        region_id: regionId,
        name: name,
        phone: phone,
        email: email,
        rights: rightsLevel
      }
      const requestParams = {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(requestBody)
      }
      try{
        const response = await fetch(`https://${domain}/api/operator/profile`, requestParams);
        if(!response.ok) throw new Error(response.message);
        fetchList();
        fetchOperator();
      }catch(e){console.error(e)} 
    }

    const requester = () => {
      if(name !== '' && curUserName !== '') {
        fetchChanges();
        setStatus();
      }
    }

    useEffect(() => {
      let lvl = 0;
      if (rightLvl) rightLvl.forEach(obj => {if(obj.access) lvl += obj.lvl} );
      setRightsLevel(lvl);
    }, [rightLvl]);

    useEffect(() => {
      setRightsLvl([
        {lvl: 1, access: rightsLevel < 128 ? one(rightsLevel) : true}, 
        {lvl: 2, access: rightsLevel < 128 ? two(rightsLevel) : true}, 
        {lvl: 4, access: rightsLevel <128 ? four(rightsLevel) : true}, 
        {lvl: 8, access: rightsLevel < 128 ? eight(rightsLevel) : true}, 
        {lvl: 16, access: rightsLevel < 128 ? sixteen(rightsLevel) : true}, 
        {lvl: 32, access: rightsLevel < 128 ? thirtytwo(rightsLevel) : true},
        {lvl: 64, access: rightsLevel < 128 ? sixtyfour(rightsLevel) : true},
        {lvl: 128, access: rightsLevel >= 128}
      ])
    }, [rightsLevel])

    useEffect(() => {
      fetchOperator();
    }, [curUserName])

    return(
      <div>
        <button onClick={setStatus} className='requestBtn'>Edit</button>
        {modal && <div className='modal-window'>
            <div className='modal-box'>
                <div className='input-areas'>
                  <label>User Name</label>
                  <input className='inputs' type='text' readOnly value={curUserName}/>
                </div>
                {/* <div className='input-areas'>
                  <label>Password</label>
                  <input className='inputs' type='text' onChange={passwordChange} value={password}/>
                  </div> */}
                <div className='input-areas'>
                  <label>Name</label>
                  <input className='inputs' type='text' onChange={nameChange} value={name}/>
                </div>
                <div className='input-areas'>
                  <label>Email</label>
                  <input className='inputs' type='text' onChange={emailChange} value={email}/>
                </div>
                <div className='input-areas'>
                  <label>Region</label>
                  <RegionAuto setType={setRegionId} regions={regions} regionL={region}/>
                </div>
                <div className='input-areas'>
                  <label>Phone</label>
                  <input className='inputs' type='text' onChange={phonesChange} value={phone}/>
                </div>
                {rightChoose()}
                <div className='modal-btns'>
                    <button className='requestBtn' onClick={requester}>Save</button>
                    <button className='closeBtn' onClick={setStatus}>Cancel</button>
                </div>
            </div>
        </div>}
        
    </div>
    )
}


export default Modal